import { render, staticRenderFns } from "./MessageListVue.vue?vue&type=template&id=1044839f&scoped=true"
import script from "./MessageListVue.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageListVue.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MessageListVue.vue?vue&type=style&index=0&id=1044839f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1044839f",
  null
  
)

export default component.exports